import { AppBar, Toolbar, Typography, Container, Button, Box } from "@mui/material";
import { Link, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Experiences from "./pages/Experiences.tsx";
import CV from "./pages/CV";
import RecruiterPrompt from "./components/RecruiterPrompt";
import EnvBadge from "./components/EnvBadge";


export default function App() {
  const loc = useLocation();
  return (
    <>
      <RecruiterPrompt />
      
      <AppBar position="sticky" elevation={0}>
        <Toolbar sx={{ gap: 2 }}>
          <Typography sx={{ flexGrow: 1, fontWeight: 600 }}>hsuire</Typography>
          <EnvBadge />
          <Button component={Link} to="/" color={loc.pathname === "/" ? "secondary" : "inherit"}>Accueil</Button>
          <Button component={Link} to="/experiences" color={loc.pathname.startsWith("/experiences") ? "secondary" : "inherit"}>Experiences</Button>
          <Button component={Link} to="/cv" color={loc.pathname.startsWith("/cv") ? "secondary" : "inherit"}>CV</Button>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ minHeight: "calc(100vh - 120px)" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/cv" element={<CV />} />
        </Routes>
      </Box>

      <Container component="footer" sx={{ py: 4, opacity: 0.7 }}>
        <Typography variant="body2">© {new Date().getFullYear()} Hugo Suire — Portfolio 🟢</Typography>
      </Container>
    </>
  );
}
